const BACKEND_URL = 'http://localhost:5000';

export const generateAffiliateLink = async (
  productUrl,
  userId = 'guest'
) => {
  try {
    const encodedUrl = encodeURIComponent(productUrl);
    const apiUrl = `${BACKEND_URL}/api/affiliate-link?url=${encodedUrl}&userId=${userId}`;

    const response = await fetch(apiUrl);

    if (!response.ok) {
      console.warn('Backend returned:', response.status);
      return { originalUrl: productUrl, affiliateUrl: productUrl };
    }

    const data = await response.json();
    console.log('Cuelinks affiliate link:', data);

    if (data.affiliate_url) {
      return {
        originalUrl: productUrl,
        affiliateUrl: data.affiliate_url,
        shortenUrl: data.shorten_url || data.affiliate_url,
      };
    }

    return { originalUrl: productUrl, affiliateUrl: productUrl };

  } catch (error) {
    console.error('Affiliate link error:', error);
    return { originalUrl: productUrl, affiliateUrl: productUrl };
  }
};

export const generateMultipleAffiliateLinks = async (
  products,
  userId = 'guest'
) => {
  try {
    const productsWithLinks = await Promise.all(
      products.map(async (product) => {
        const linkData = await generateAffiliateLink(
          product.affiliateUrl,
          userId
        );
        return {
          ...product,
          affiliateUrl: linkData.affiliateUrl,
          shortenUrl: linkData.shortenUrl || linkData.affiliateUrl,
        };
      })
    );
    return productsWithLinks;
  } catch (error) {
    console.error('Error generating links:', error);
    return products;
  }
};